// extracted by mini-css-extract-plugin
export default {"info":"StreamInfo_info__Ec0Rt","info__field":"StreamInfo_info__field__FWEAC","info__field-legend":"StreamInfo_info__field-legend__l6zss"};